// removed by extract-text-webpack-plugin
module.exports = {"RecipeCard":"RecipeCard__RecipeCard__mPqTO","Text":"RecipeCard__Text__1VWHb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipe/RecipeCard/RecipeCard.css
// module id = 112
// module chunks = 0